
import { BLOG_ARTICLE, BLOG_ARTICLES_SIMILAR } from '@/const/api/blog';
import LayoutContainer from '@/components/layout/Container';
import ShareSocialNetwork from '@/components/common/ShareSocialNetwork';

export default {
    name: 'BlogItem',
    head() {
        if (this.article) {
            const meta = [
                {
                    hid: 'og:url',
                    name: 'og:url',
                    content: `https://cofi.ru/blog/${this.article.slug}`
                },
                {
                    hid: 'og:type',
                    name: 'og:type',
                    content: 'article'
                }
            ];
            const head = { meta };
            if (this.article?.seo?.title) {
                head.title = this.article.seo.title;
                meta.push(
                    {
                        hid: 'og:title',
                        name: 'og:title',
                        content: this.article?.seo?.title
                    }
                )
            }
            if (this.article?.seo?.description) {
                meta.push(
                    {
                        hid: 'description',
                        name: 'description',
                        content: this.article?.seo?.description
                    },
                    {
                        hid: 'og:description',
                        name: 'og:description',
                        content: this.article?.seo?.description
                    }
                );
            }
            if (this.article?.seo?.keywords) {
                meta.push(
                    {
                        hid: 'keywords',
                        name: 'keywords',
                        content: this.article?.seo?.keywords
                    }
                );
            }
            if (this.article?.images && this.article?.images.cover_840x418) {
                meta.push(
                    {
                        hid: 'og:image',
                        name: 'og:image',
                        property: 'og:image',
                        content: this.serverImage(`${this.article.images.cover_840x418.download_id}.png`)
                    }
                )
            }
            return head;
        }
        return {};
    },
    components: {
        LayoutContainer,
        ShareSocialNetwork,
        BlogItemPreview: () => import('@/components/blog/BlogItemPreview')
    },
    data() {
        return {
            article: null,
            similarArticles: []
        }
    },
    async fetch() {
        await this.$axios(BLOG_ARTICLE(this.$route.params.slug))
            .then(async ({data}) => {
                this.article = data?.item
                if (this.article) {
                    this.similarArticles = await this.$axios(BLOG_ARTICLES_SIMILAR(this.article.id)).then(({data}) => data?.items)
                }
            })
            .catch(() => {
                this.$nuxt.context.redirect({name:'blog'});
            })
    },
    computed: {
        description() {
            return this.article?.seo?.description || '';
        }
    }
}
